export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-v1-1200-82ec4f722fe7bab6a60512e9afb393bb.webp";